/**
 * Release notes arrive from the backend as one newline-separated string in
 * `version_controls.release_notes` — one line per change, and possibly a final
 * line addressed to this tenant alone (one web image serves every tenant, so a
 * change requested by one client still ships to all of them).
 *
 * This lives outside UpdateAvailableModal on purpose: importing that component
 * pulls antd's barrel, which cannot resolve `@rc-component/pagination/locale/en_US`
 * in this repo's jest setup, so any spec touching it runs zero tests. Keeping the
 * parsing pure means the logic worth covering is actually covered.
 */
export function parseReleaseNotes(notes?: string | null): string[] {
  if (!notes) return [];
  return notes
    .split('\n')
    // Authors paste bullets in by hand; strip a leading marker so the UI does
    // not render "• • Fixed ...".
    .map((line) => line.replace(/^\s*[-•*]\s*/, '').trim())
    .filter((line) => line.length > 0);
}
